import { render, staticRenderFns } from "./DocumentsSubmitButtonNModal.vue?vue&type=template&id=468d35c8&"
import script from "./DocumentsSubmitButtonNModal.vue?vue&type=script&lang=js&"
export * from "./DocumentsSubmitButtonNModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('468d35c8')) {
      api.createRecord('468d35c8', component.options)
    } else {
      api.reload('468d35c8', component.options)
    }
    module.hot.accept("./DocumentsSubmitButtonNModal.vue?vue&type=template&id=468d35c8&", function () {
      api.rerender('468d35c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/greenOperation/components/DocumentsSubmitButtonNModal.vue"
export default component.exports